module.exports = __webpack_public_path__ + "static/img/web_hosting_category.dde1ef1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/old/web_hosting_category.jpg
// module id = uslq
// module chunks = 1